module.exports = __webpack_public_path__ + "static/media/publish-schedule-stories-mobile-es.f7d6c184.png";